import { UserUpsertForm } from "../../components/forms/upsert-user-form/user-upsert-form";
import { useAssociationUserShow } from "../../context/user-show.context";

export const ProfileSettings = () => {
  const { associationUser } = useAssociationUserShow();
  return (
    <div className={"bg-white  px-2 h-full"}>
      <UserUpsertForm user={associationUser} />
    </div>
  );
};
